const diet = {
  getlist: 'diet/getlist',
  add: 'diet/add',
  update: 'diet/update',
  remove: 'diet/remove',
  get: 'diet/get',
  getall: 'diet/getall',
}
export default diet
